/**
 *所有API接口url
 */
let urls = {}

/**
 * 用户信息部分
 * @name urls.user
 */

urls.user = {
  // 登录
  login: '/api/user/login',
  // 获取用户登录信息
  loginStatus: '/api/user/getCurUserInfo',
  // 退出登录
  logout: '/api/user/logout',
  find: '/api/user/find',
  get: '/api/user/get',
  create: '/api/user/create',
  update: '/api/user/update',
  delete: '/api/user/delete',
  activate: '/api/user/activate',
  changePassword: '/api/user/changePassword',
  resetPassword: '/api/user/resetPassword',
  import: '/api/user/import'
}
urls.common = {
  getQiniuUptoken: '/api/qiniu/uptoken'
}
urls.file = {
  upload: '/api/file/upload',
}

urls.department = {
  find: '/api/department/find',
  get: '/api/department/get',
  create: '/api/department/create',
  update: '/api/department/update',
  delete: '/api/department/delete',
}
urls.region = {
  find: '/api/region/find',
  get: '/api/region/get',
  create: '/api/region/create',
  update: '/api/region/update',
  delete: '/api/region/delete',
}
/**
 * 角色部分
 * @name urls.role
 */

urls.role = {
  find: '/api/role/find',
  get: '/api/role/get',
  create: '/api/role/create',
  update: '/api/role/update',
  delete: '/api/role/delete',
  getPermission: '/api/role/getPermission',
}
urls.test = {
  find: '/api/test/find',
  get: '/api/test/get',
  create: '/api/test/create',
  update: '/api/test/update',
  delete: '/api/test/delete',
  getTestResult: '/api/test/getTestResult',
  getTestResultDetail: '/api/test/getTestResultDetail',
  exportTestResultDetail: '/api/test/exportTestResultDetail',
}
urls.testPaper = {
  find: '/api/testPaper/find',
  get: '/api/testPaper/get',
  create: '/api/testPaper/create',
  update: '/api/testPaper/update',
  delete: '/api/testPaper/delete',
  findQuestion: '/api/testPaper/findQuestion',
  addQuestion: '/api/testPaper/addQuestion',
  removeQuestion: '/api/testPaper/removeQuestion',
}
urls.question = {
  find: '/api/question/find',
  get: '/api/question/get',
  create: '/api/question/create',
  update: '/api/question/update',
  delete: '/api/question/delete',
  findCategory: '/api/question/findCategory',
  createCategory: '/api/question/createCategory',
  updateCategory: '/api/question/updateCategory',
  deleteCategory: '/api/question/deleteCategory',
  findForTestPaper: '/api/question/findForTestPaper',
}
urls.article = {
  find: '/api/article/find',
  get: '/api/article/get',
  create: '/api/article/create',
  update: '/api/article/update',
  delete: '/api/article/delete',
  findCategory: '/api/article/findCategory',
  createCategory: '/api/article/createCategory',
  updateCategory: '/api/article/updateCategory',
  deleteCategory: '/api/article/deleteCategory',
  setTopmost: '/api/article/setTopmost'
}
urls.resource = {
  find: '/api/resource/find',
  get: '/api/resource/get',
  create: '/api/resource/create',
  update: '/api/resource/update',
  delete: '/api/resource/delete',
  findCategory: '/api/resource/findCategory',
  createCategory: '/api/resource/createCategory',
  updateCategory: '/api/resource/updateCategory',
  deleteCategory: '/api/resource/deleteCategory'
}
urls.report = {
  find: '/api/report/find',
  updateComment: '/api/report/updateComment',
  export: '/api/report/export',
  updateText: '/api/report/updateText',
}

export default urls



// WEBPACK FOOTER //
// ./src/config/urls.js